import React from 'react';
import { WARNING, WARNING_BG, WARNING_TEXT, DANGER, DANGER_BG, DANGER_TEXT, SUBTLE, BODY_TEXT } from './tokens';
import { useSoft, SOFT } from './SurfaceStyleContext';

const TONES = {
  warning: { border: WARNING, bg: WARNING_BG, color: WARNING_TEXT },
  danger: { border: DANGER, bg: DANGER_BG, color: DANGER_TEXT },
  grey: { border: SUBTLE, bg: '#fff', color: BODY_TEXT },
  black: { border: '#000', bg: '#fff', color: '#000' },
};

/** Alert callout: `THIS ONE IS NOT OURS`, `THE ROOM IS FULL`, `THIS PARTY NEEDS A HOST`. */
/** Soft tints (§6): grey #F2F2F2, red #FEE2E2 with a red title, amber #FFF8EA with #B45309. */
const SOFT_TONES = {
  warning: { bg: SOFT.amberTint, title: SOFT.amber },
  danger: { bg: SOFT.redTint, title: SOFT.red },
  grey: { bg: SOFT.chip, title: '#000' },
  black: { bg: SOFT.chip, title: '#000' },
};

export default function Callout({ tone = 'grey', title, children, mobile = false, className = '', testId = 'callout' }) {
  const t = TONES[tone] || TONES.grey;
  const soft = useSoft();
  if (soft) {
    const st = SOFT_TONES[tone] || SOFT_TONES.grey;
    return (
      <div className={`flex flex-col ${className}`} style={{ gap: mobile ? 4 : 6, padding: mobile ? '14px 16px' : '18px 20px', borderRadius: mobile ? 18 : 20, background: st.bg }} data-testid={testId} data-soft="1">
        {title && <div className="font-mono font-bold uppercase" style={{ fontSize: mobile ? 10 : 11, letterSpacing: '0.16em', color: st.title }}>{title}</div>}
        <div className="font-mono" style={{ fontSize: mobile ? 12 : 13, lineHeight: mobile ? 1.55 : 1.6, color: SOFT.body }}>{children}</div>
      </div>
    );
  }
  return (
    <div className={`border-2 ${className}`} style={{ borderColor: t.border, background: t.bg, color: t.color, padding: mobile ? '12px 14px' : '14px 16px' }} data-testid={testId}>
      {title && <div className="font-mono font-bold uppercase" style={{ fontSize: mobile ? 11 : 12, letterSpacing: '0.1em', marginBottom: mobile ? 4 : 6 }}>{title}</div>}
      <div className="font-mono" style={{ fontSize: mobile ? 12 : 13, lineHeight: 1.6 }}>{children}</div>
    </div>
  );
}
